import React, { useContext, useEffect, useState } from 'react';
//import { ChangeEventHandler } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from 'sweetalert2';
import authContext from '../../context/auth/authContext.js';
import { RootState } from '../../presentation/redux/store/RootState';
import { Pines } from '../../domain/models/Pines';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { pinList } from '../action/pinList';
import { pinDelete } from '../action/pinDelete';
import { updatePinStatus } from '../action/updatePinStatus';
import { reiniciaIntentos } from '../action/reiniciaIntentos';
import { getHorarios } from '../action/getHorarios';
import { LoadingScreen } from '../Layout/LoadingScreen';
import { ModalNuevoPin } from './ModalNuevoPin';
import { ModalEditar } from './ModalEditar';
import { ModalHorarios } from './ModalHorarios';
import { sessionEnd } from '../action/sessionEnd.js';

const initialState = {
  uid: '',
  nombre: '',
  telefono: '',
  email: '',
  tiene_2fa: false,
  password: '',
  pendiente_2fa: false
}

export const PinesUsuarios = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const AuthContext = useContext(authContext);
  const { es_pin, token } = AuthContext;
  const pinesU = useSelector((s: RootState) => s.pinesState.pinesUsuarios);
  const { isLoadingActive } = useSelector((s: RootState) => s.uiState);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenNew, setIsOpenNew] = useState<boolean>(false);
  const [isOpenHorarios, setIsOpenHorarios] = useState<boolean>(false);
  const [editUser, seteditUser] = useState<string>('');
  const [editValues, setEditValues] = useState(initialState);

  useEffect(() => {
    dispatch(UIActions.uiLoadActive());
    pinList(token, dispatch);
  }, [token, dispatch]);

  //Validar acceso
  useEffect(() => {
    if (es_pin === true) {
      history('/home');
    }
  }, [es_pin, history]);

  //Nuevo Pin
  const toggleNewPin = () => {
    setIsOpenNew(!isOpenNew);
  }

  //Editar un pin
  const openEditar = (usuario: any, nombre: any, telefono: any, email: any, tiene_2fa: boolean, pendiente_2fa: boolean) => {
    const values = {
      uid: usuario,
      nombre: nombre,
      telefono: telefono,
      email: email,
      tiene_2fa: tiene_2fa,
      pendiente_2fa: pendiente_2fa,
      password: ''
    }
    toggle();
    setEditValues(values);
  }

  const toggle = () => setIsOpen(!isOpen);

  // const onChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget }) => {
  //   setEditValues({
  //     ...editValues,
  //     [currentTarget.name]: currentTarget.value
  //   });
  // }

  //Horarios
  const toggleHorarios = (usuario: any) => {
    if (!isOpenHorarios) {
      dispatch(UIActions.uiLoadActive());
      getHorarios(token, usuario, dispatch);
    }
    setIsOpenHorarios(!isOpenHorarios);
    seteditUser(usuario);
  }

  //Editar Status
  const editarStatus = (usuario: any) => {
    dispatch(UIActions.uiLoadActive());
    updatePinStatus(token, usuario, dispatch);
  }

  //Restablecer Intentos
  const resetIntentos = (usuario: any) => {
    dispatch(UIActions.uiLoadActive());
    reiniciaIntentos(token, usuario, dispatch);
  }

  //Terminar sesión en app para un pin
  const hanleSessionEnd = (usuario: any) => {
    Swal.fire({
      title: "¿Forzar el cierre de sesión para este pin usuario?",
      text: "Todas las sesiones del usuario " + usuario + " serán cerradas",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(UIActions.uiLoadActive());
        sessionEnd(token, usuario, dispatch);
      }
    })
  }

  //Eliminar Pin
  const deletePin = (usuario: any) => {
    Swal.fire({
      title: "¿Eliminar este pin usuario?",
      text: "El pin usuario " + usuario + " será eliminado",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(UIActions.uiLoadActive());
        pinDelete(token, usuario, dispatch);
      }
    })
  }

  return (
    <>
      {(isLoadingActive) &&
        < LoadingScreen />
      }
      <div className='px-3 py-4'>
        <div className='d-flex align-items-end flex-column'>
          <Button onClick={() => toggleNewPin()}><i className="fas fa-user-plus" aria-hidden="true"></i>&#160;Nuevo Pin</Button>
        </div>
        <div>
          <h3>
            Pines Usuarios
            <small className="text-muted">&#160;registro</small>
          </h3>
        </div>
        <div className="table-responsive resp pinesTable">
          <Table hover responsive className="table resp">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Último Acceso</th>
                <th>Intentos</th>
                <th>Estado</th>
                <th style={{ whiteSpace: 'nowrap' }}>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {pinesU && pinesU.map((item: Pines) => <tr className="tablaPines" key={item.usuario}>
                <td>{item.usuario}</td>
                <td>{item.nombre}</td>
                <td>{item.telefono}</td>
                <td>{item.ultimo_acceso}</td>
                <td>{item.intentos}</td>
                <td>{item.estatus}</td>
                <td className='table-opciones'>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">2FA {item.pendiente_2fa && 'Pendiente'} {(item.tiene_2fa && !item.pendiente_2fa) && 'Activo'}</Tooltip>} >
                    <span className={`d-inline-block ${item.tiene_2fa ? undefined : 'btn-disabled'}`}>
                      <Button style={{ cursor: 'default' }}
                        className={`btn-action ' ${item.pendiente_2fa ? 'text-warning' : undefined}  ${(item.tiene_2fa && !item.pendiente_2fa) ? 'text-success' : undefined}`}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-shield-alt"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Editar</Tooltip>} >
                    <span className="d-inline-block">
                      <Button
                        className='btn-action'
                        onClick={() => openEditar(item.usuario, item.nombre, item.telefono, item.email, item.tiene_2fa, item.pendiente_2fa)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-user-edit"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Horarios</Tooltip>}>
                    <span className="d-inline-block">
                      <Button
                        className='btn-action'
                        onClick={() => toggleHorarios(item.usuario)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-user-clock"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">
                    Restablecer intentos
                  </Tooltip>}>
                    <span className="d-inline-block">
                      <Button
                        className='btn-action'
                        onClick={() => resetIntentos(item.usuario)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-redo"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">
                    {(item.estatus !== 'BLOQUEADO' ? <span>Bloquear</span> : <span>Desbloquear</span>)}
                  </Tooltip>}>
                    <span className="d-inline-block">
                      <Button
                        className='btn-action'
                        onClick={() => editarStatus(item.usuario)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className={(item.estatus !== 'BLOQUEADO' ? `fas fa-unlock` : `fas fa-lock`)}></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Terminar sesión</Tooltip>}>
                    <span className="d-inline-block">
                      <Button
                        className='btn-action'
                        onClick={() => hanleSessionEnd(item.usuario)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-sign-out-alt"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Eliminar</Tooltip>}>
                    <span className="d-inline-block">
                      <Button
                        className='btn-action text-danger'
                        onClick={() => deletePin(item.usuario)}
                        onFocus={(e: any) => e.target.blur()}
                        data-toggle="tooltip"
                        data-placement="top"
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>)}
            </tbody>
          </Table>
        </div>
        <ModalNuevoPin
          isOpen={isOpenNew}
          toggle={toggleNewPin}
          token={token}
        />
        <ModalEditar
          isOpen={isOpen}
          toggle={toggle}
          token={token}
          values={editValues}
        />
        <ModalHorarios
          isOpen={isOpenHorarios}
          toggle={toggleHorarios}
          token={token}
          usuario={editUser}
        />
      </div>
    </>
  )
}